<div class="card">
  <div class="card-content">
    <div class="access-tabs" role="tablist">
      <button type="button" class="access-tab" role="tab"
        [class.access-tab--active]="activeTab === 'matrix'"
        [attr.aria-selected]="activeTab === 'matrix'"
        (click)="selectTab('matrix')">
        <i class="pi pi-table"></i> Role / Page Matrix
      </button>
      <button type="button" class="access-tab" role="tab"
        [class.access-tab--active]="activeTab === 'groups'"
        [attr.aria-selected]="activeTab === 'groups'"
        (click)="selectTab('groups')">
        <i class="pi pi-users"></i> Group Members
      </button>
      <button type="button" class="access-tab" role="tab"
        [class.access-tab--active]="activeTab === 'multi'"
        [attr.aria-selected]="activeTab === 'multi'"
        (click)="selectTab('multi')">
        <i class="pi pi-sitemap"></i> Multiple Groups
        <span class="access-tab-badge" *ngIf="multiLoaded && multiGroup.length > 0">
          {{ multiGroup.length }}
        </span>
      </button>
      <button type="button" class="access-tab" role="tab"
        [class.access-tab--active]="activeTab === 'ungrouped'"
        [attr.aria-selected]="activeTab === 'ungrouped'"
        (click)="selectTab('ungrouped')">
        <i class="pi pi-user-minus"></i> No Access Group
        <span class="access-tab-badge" *ngIf="ungroupedLoaded && ungrouped.length > 0">
          {{ ungrouped.length }}
        </span>
      </button>
    </div>

    <ng-container *ngIf="activeTab === 'matrix'">
    <!-- Each card is a filter: clicking narrows the table to the pages it counts, and
         clicking the active one clears it again. -->
    <div class="stats-cards-row">
      <div class="stats-card stats-card--total stats-card--clickable"
        [class.stats-card--active]="statFilter === null"
        (click)="setStatFilter(null)">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ allRows.length }}</span>
          <span class="stats-card-label">Guarded Pages</span>
          <span class="stats-card-sublabel">All pages</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-file"></i></div>
      </div>
      <div class="stats-card stats-card--danger stats-card--clickable"
        [class.stats-card--active]="statFilter === 'adminOnly'"
        (click)="setStatFilter('adminOnly')">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ adminOnlyCount }}</span>
          <span class="stats-card-label">Admin Only</span>
          <span class="stats-card-sublabel">No other role</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-lock"></i></div>
      </div>
      <div class="stats-card stats-card--warning stats-card--clickable"
        [class.stats-card--active]="statFilter === 'broadlyOpen'"
        (click)="setStatFilter('broadlyOpen')">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ broadlyOpenCount }}</span>
          <span class="stats-card-label">Broadly Open</span>
          <span class="stats-card-sublabel">{{ broadlyOpenThreshold }}+ roles</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-unlock"></i></div>
      </div>
      <div class="stats-card stats-card--success stats-card--clickable"
        [class.stats-card--active]="statFilter === 'shared'"
        (click)="setStatFilter('shared')">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ sharedCount }}</span>
          <span class="stats-card-label">Shared</span>
          <span class="stats-card-sublabel">2–{{ broadlyOpenThreshold - 1 }} roles</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-users"></i></div>
      </div>
    </div>

    <div class="filter-bar filter-bar-collapsible mb-4"
         [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label for="roleFilter" class="filter-label">Role can access</label>
          <p-select id="roleFilter" [(ngModel)]="selectedRole" (ngModelChange)="applyFilters()"
            [options]="roleOptions" optionLabel="label" optionValue="value" placeholder="All roles"
            [showClear]="true" panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="areaFilter" class="filter-label">Area</label>
          <p-select id="areaFilter" [(ngModel)]="selectedArea" (ngModelChange)="applyFilters()"
            [options]="areaOptions" optionLabel="label" optionValue="value" placeholder="All areas"
            [showClear]="true" [filter]="true" filterPlaceholder="Search area..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
      </div>
      <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
        <button type="button" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <!-- Area grouping renders a subheader wherever the area changes between consecutive
         rows, so the row order must stay area-first. Sorting is therefore applied in the
         component (sortMatrix) within each area, rather than by p-table, which would
         interleave areas and repeat their subheaders. -->
    <p-table [value]="rows" dataKey="path" styleClass="p-datatable compact-table access-matrix-table"
      [scrollable]="true" scrollHeight="flex" [rowGroupMode]="'subheader'" groupRowsBy="area"
      [tableStyle]="{ 'min-width': '100%' }">
      <ng-template pTemplate="header">
        <tr>
          <th class="th-page th-sortable" (click)="sortMatrix()">
            Page
            <i class="pi" [class.pi-sort-alt]="matrixSortAsc === null"
               [class.pi-sort-amount-up-alt]="matrixSortAsc === true"
               [class.pi-sort-amount-down]="matrixSortAsc === false"></i>
          </th>
          <th class="th-role" *ngFor="let role of roles">{{ role.label }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="groupheader" let-row>
        <tr pRowGroupHeader class="matrix-group-row">
          <td [attr.colspan]="roles.length + 1">
            <span class="group-area">{{ row.area }}</span>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row>
        <tr>
          <td class="td-page">{{ row.title }}</td>
          <td class="td-role" *ngFor="let cell of row.cells"
            [pTooltip]="tooltipFor(row, cell.role)" tooltipPosition="top">
            <span class="access-mark"
              [class.access-mark--direct]="cell.kind === 'direct'"
              [class.access-mark--inherited]="cell.kind === 'inherited'"
              [class.access-mark--none]="cell.kind === 'none'">
              <i class="pi pi-check" *ngIf="cell.kind !== 'none'"></i>
              <ng-container *ngIf="cell.kind === 'none'">·</ng-container>
            </span>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row">
          <td [attr.colspan]="roles.length + 1" class="table-empty-cell">
            <div class="empty-state">
              <div class="empty-icon"><i class="pi pi-inbox"></i></div>
              <p class="empty-message">No pages found</p>
              <p class="empty-description">Update filters to see pages</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    </ng-container>

    <ng-container *ngIf="activeTab === 'groups'">
      <div class="state-panel" *ngIf="groupsError">
        <div class="state-icon state-icon--error"><i class="pi pi-exclamation-triangle"></i></div>
        <p class="state-title">{{ groupsError }}</p>
        <p class="state-detail">{{ groupsErrorDetail }}</p>
        <button type="button" class="state-retry-btn" (click)="retry()" [disabled]="groupsLoading">
          <i class="pi pi-refresh"></i> Try again
        </button>
      </div>

      <!-- Covers "not loaded yet" rather than only "currently loading", so there is no
           frame in which none of these three blocks renders and the tab looks blank. -->
      <div class="state-panel" *ngIf="!groupsError && !groupsLoaded">
        <div class="state-icon"><i class="pi pi-spin pi-spinner"></i></div>
        <p class="state-title">Loading access groups</p>
        <p class="state-detail">Reading group membership from Microsoft Entra...</p>
      </div>

      <div class="groups-layout" *ngIf="!groupsError && groupsLoaded">
        <!-- Group picker -->
        <div class="groups-list">
          <button type="button" class="group-chip" *ngFor="let group of groups"
            [class.group-chip--active]="group.role === selectedGroupRole"
            [class.group-chip--broken]="!group.isConfigured || group.memberCount === null"
            [disabled]="!group.isConfigured || group.memberCount === null"
            [pTooltip]="group.error || ''" tooltipPosition="right"
            (click)="selectGroup(group.role)">
            <span class="group-chip-label">{{ group.label }}</span>
            <span class="group-chip-count" *ngIf="group.memberCount !== null">{{ group.memberCount }}</span>
            <span class="group-chip-count group-chip-count--error" *ngIf="group.memberCount === null">
              <i class="pi pi-exclamation-circle"></i>
            </span>
          </button>
        </div>

        <!-- Members of the selected group -->
        <div class="groups-detail">
          <ng-container *ngIf="groupMembers || membersLoading">
            <div class="state-panel" *ngIf="groupMembers?.error">
              <div class="state-icon state-icon--error"><i class="pi pi-exclamation-triangle"></i></div>
              <p class="state-title">{{ groupMembers?.label || 'This group' }} could not be read</p>
              <p class="state-detail">{{ groupMembers?.error }}</p>
            </div>

            <ng-container *ngIf="!groupMembers?.error">
              <div class="members-header">
                <div class="members-title">
                  <span class="members-group">{{ groupMembers?.label }}</span>
                  <span class="members-count">{{ groupMembers?.members?.length || 0 }} members</span>
                </div>
                <label class="drift-toggle" *ngIf="driftCount > 0">
                  <input type="checkbox" [(ngModel)]="showOnlyDrift" />
                  Needs review only ({{ driftCount }})
                </label>
              </div>

              <div class="drift-banner" *ngIf="driftCount > 0">
                <i class="pi pi-exclamation-triangle"></i>
                <span><strong>{{ driftCount }}</strong> with no active employee record</span>
              </div>

              <p-table [value]="visibleMembers" [loading]="membersLoading"
                [scrollable]="true" scrollHeight="flex"
                [paginator]="true" [alwaysShowPaginator]="false" [rows]="25"
                [rowsPerPageOptions]="[10, 25, 50, 100]" [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} members"
                [tableStyle]="{ 'min-width': '100%' }"
                styleClass="p-datatable compact-table no-column-lines">
                <ng-template pTemplate="header">
                  <tr>
                    <th pSortableColumn="displayName">
                      Name
                      <p-sortIcon field="displayName" />
                    </th>
                    <th pSortableColumn="email">
                      Email
                      <p-sortIcon field="email" />
                    </th>
                    <th pSortableColumn="jobTitle">
                      Job Title
                      <p-sortIcon field="jobTitle" />
                    </th>
                    <!-- Sorted on the resolved drift reason, so the rows needing review
                         group together rather than sorting on a raw boolean. -->
                    <th pSortableColumn="isActiveEmployee">
                      Status
                      <p-sortIcon field="isActiveEmployee" />
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-member>
                  <tr [class.member-row--drift]="driftReason(member)">
                    <td>
                      <span class="member-name">{{ member.displayName }}</span>
                      <span class="member-disabled" *ngIf="member.accountEnabled === false">
                        Sign-in disabled
                      </span>
                    </td>
                    <td class="member-email">{{ member.email }}</td>
                    <td>{{ member.jobTitle || '—' }}</td>
                    <td>
                      <span class="member-status member-status--ok" *ngIf="!driftReason(member)">
                        <i class="pi pi-check"></i> Active employee
                      </span>
                      <span class="member-status member-status--warn" *ngIf="driftReason(member)">
                        <i class="pi pi-exclamation-triangle"></i> {{ driftReason(member) }}
                      </span>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr class="table-empty-row">
                    <td colspan="4" class="table-empty-cell">
                      <div class="empty-state">
                        <div class="empty-icon"><i class="pi pi-inbox"></i></div>
                        <p class="empty-message">
                          {{ showOnlyDrift ? 'Nothing needs review' : 'No members' }}
                        </p>
                        <p class="empty-description">
                          {{ showOnlyDrift
                             ? 'Every member matches an active employee'
                             : 'This Entra group has no members' }}
                        </p>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </ng-container>
          </ng-container>
        </div>
      </div>

    </ng-container>

    <ng-container *ngIf="activeTab === 'multi'">
      <div class="state-panel" *ngIf="multiError">
        <div class="state-icon state-icon--error"><i class="pi pi-exclamation-triangle"></i></div>
        <p class="state-title">{{ multiError }}</p>
        <p class="state-detail">
          The access groups could not be read, so the people holding more than one of them
          cannot be listed.
        </p>
        <button type="button" class="state-retry-btn" (click)="retry()" [disabled]="multiLoading">
          <i class="pi pi-refresh"></i> Try again
        </button>
      </div>

      <div class="state-panel" *ngIf="!multiError && !multiLoaded">
        <div class="state-icon"><i class="pi pi-spin pi-spinner"></i></div>
        <p class="state-title">Checking group membership</p>
        <p class="state-detail">Reading every access group from Microsoft Entra...</p>
      </div>

      <ng-container *ngIf="!multiError && multiLoaded">
        <div class="stats-cards-row">
          <div class="stats-card stats-card--total">
            <div class="stats-card-main">
              <span class="stats-card-value">{{ multiGroup.length }}</span>
              <span class="stats-card-label">In Multiple Groups</span>
              <span class="stats-card-sublabel">2 or more roles</span>
            </div>
            <div class="stats-card-icon"><i class="pi pi-sitemap"></i></div>
          </div>
          <div class="stats-card stats-card--warning">
            <div class="stats-card-main">
              <span class="stats-card-value">{{ widestAccessCount }}</span>
              <span class="stats-card-label">Widest Access</span>
              <span class="stats-card-sublabel">{{ broadlyOpenThreshold }}+ roles</span>
            </div>
            <div class="stats-card-icon"><i class="pi pi-unlock"></i></div>
          </div>
          <div class="stats-card stats-card--danger">
            <div class="stats-card-main">
              <span class="stats-card-value">{{ multiNeedsReviewCount }}</span>
              <span class="stats-card-label">Needs Review</span>
              <span class="stats-card-sublabel">Also flagged</span>
            </div>
            <div class="stats-card-icon"><i class="pi pi-exclamation-triangle"></i></div>
          </div>
        </div>

        <div class="filter-bar filter-bar-collapsible mb-4"
             [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
          <div class="filter-bar-filters">
            <div class="filter-field">
              <label for="minRoleFilter" class="filter-label">Minimum roles</label>
              <p-select id="minRoleFilter" [(ngModel)]="minRoleCount"
                [options]="minRoleCountOptions" optionLabel="label" optionValue="value"
                placeholder="Any number of roles" [showClear]="true"
                panelStyleClass="filter-dropdown-panel" appendTo="body" />
            </div>
            <div class="filter-field">
              <label for="multiRoleFilter" class="filter-label">Holds role</label>
              <p-select id="multiRoleFilter" [(ngModel)]="selectedMultiRole"
                [options]="multiRoleOptions" optionLabel="label" optionValue="value"
                placeholder="All roles" [showClear]="true" [filter]="true"
                filterPlaceholder="Search role..."
                panelStyleClass="filter-dropdown-panel" appendTo="body" />
            </div>
          </div>
          <div class="filter-bar-actions" *ngIf="hasActiveMultiFilters()">
            <button type="button" class="btn-clear-filters" (click)="clearMultiFilters()"
              title="Clear all filters">
              <i class="pi pi-filter-slash"></i>
            </button>
          </div>
        </div>

        <p-table [value]="filteredMultiGroup" [loading]="multiLoading"
          [scrollable]="true" scrollHeight="flex"
          [paginator]="true" [alwaysShowPaginator]="false" [rows]="25"
          [rowsPerPageOptions]="[10, 25, 50, 100]" [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} people"
          [tableStyle]="{ 'min-width': '100%' }"
          styleClass="p-datatable compact-table no-column-lines">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="displayName">
                Name
                <p-sortIcon field="displayName" />
              </th>
              <th pSortableColumn="email">
                Email
                <p-sortIcon field="email" />
              </th>
              <th pSortableColumn="jobTitle">
                Job Title
                <p-sortIcon field="jobTitle" />
              </th>
              <th class="th-rolecount" pSortableColumn="roleCount">
                Roles
                <p-sortIcon field="roleCount" />
              </th>
              <th>Groups Held</th>
              <th pSortableColumn="status">
                Status
                <p-sortIcon field="status" />
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-person>
            <tr [class.member-row--drift]="person.needsReview">
              <td>
                <span class="member-name">{{ person.displayName }}</span>
                <span class="member-disabled" *ngIf="person.accountEnabled === false">
                  Sign-in disabled
                </span>
              </td>
              <td class="member-email">{{ person.email }}</td>
              <td>{{ person.jobTitle || '—' }}</td>
              <td class="td-rolecount">
                <span class="role-count-pill"
                  [class.role-count-pill--wide]="person.roleCount >= broadlyOpenThreshold">
                  {{ person.roleCount }}
                </span>
              </td>
              <td>
                <span class="role-chip" *ngFor="let role of person.roles">{{ role }}</span>
              </td>
              <td>
                <span class="member-status member-status--ok" *ngIf="!person.needsReview">
                  <i class="pi pi-check"></i> {{ person.status }}
                </span>
                <span class="member-status member-status--warn" *ngIf="person.needsReview">
                  <i class="pi pi-exclamation-triangle"></i> {{ person.status }}
                </span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr class="table-empty-row">
              <td colspan="6" class="table-empty-cell">
                <div class="empty-state" *ngIf="!hasActiveMultiFilters()">
                  <div class="empty-icon"><i class="pi pi-check-circle"></i></div>
                  <p class="empty-message">Nobody holds more than one role</p>
                  <p class="empty-description">
                    Every person is in exactly one access group
                  </p>
                </div>
                <div class="empty-state" *ngIf="hasActiveMultiFilters()">
                  <div class="empty-icon"><i class="pi pi-inbox"></i></div>
                  <p class="empty-message">No people found</p>
                  <p class="empty-description">Update filters to see people</p>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="activeTab === 'ungrouped'">
      <div class="state-panel" *ngIf="ungroupedError">
        <div class="state-icon state-icon--error"><i class="pi pi-exclamation-triangle"></i></div>
        <p class="state-title">{{ ungroupedError }}</p>
        <p class="state-detail">
          The employee list could not be compared against the access groups, so this tab
          cannot confirm who is missing access.
        </p>
        <button type="button" class="state-retry-btn" (click)="retry()" [disabled]="ungroupedLoading">
          <i class="pi pi-refresh"></i> Try again
        </button>
      </div>

      <ng-container *ngIf="!ungroupedError">
        <div class="filter-bar filter-bar-collapsible mb-4"
             [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
          <div class="filter-bar-filters">
            <div class="filter-field">
              <label for="ungroupedRoleFilter" class="filter-label">Role</label>
              <p-select id="ungroupedRoleFilter" [(ngModel)]="selectedUngroupedRole"
                [options]="ungroupedRoleOptions" optionLabel="label" optionValue="value"
                placeholder="All roles" [showClear]="true" [filter]="true"
                filterPlaceholder="Search role..."
                panelStyleClass="filter-dropdown-panel" appendTo="body" />
            </div>
            <div class="filter-field">
              <label for="ungroupedSgFilter" class="filter-label">Service Group</label>
              <p-select id="ungroupedSgFilter" [(ngModel)]="selectedUngroupedServiceGroup"
                [options]="ungroupedServiceGroupOptions" optionLabel="label" optionValue="value"
                placeholder="All service groups" [showClear]="true" [filter]="true"
                filterPlaceholder="Search service group..."
                panelStyleClass="filter-dropdown-panel" appendTo="body" />
            </div>
          </div>
          <div class="filter-bar-actions" *ngIf="hasActiveUngroupedFilters()">
            <button type="button" class="btn-clear-filters" (click)="clearUngroupedFilters()"
              title="Clear all filters">
              <i class="pi pi-filter-slash"></i>
            </button>
          </div>
        </div>

        <div class="drift-banner" *ngIf="!ungroupedLoading && filteredUngrouped.length > 0">
          <i class="pi pi-exclamation-triangle"></i>
          <span>
            <strong>{{ ungrouped.length }}</strong> active employees hold no access role —
            they can sign in but land on the unauthorized page.
          </span>
        </div>

        <p-table [value]="filteredUngrouped" [loading]="ungroupedLoading"
          [scrollable]="true" scrollHeight="flex"
          [paginator]="true" [alwaysShowPaginator]="false" [rows]="25"
          [rowsPerPageOptions]="[10, 25, 50, 100]" [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} employees"
          [tableStyle]="{ 'min-width': '100%' }"
          styleClass="p-datatable compact-table no-column-lines">
          <ng-template pTemplate="header">
            <tr>
              <th class="th-index">#</th>
              <th pSortableColumn="name">
                Employee
                <p-sortIcon field="name" />
              </th>
              <th pSortableColumn="email">
                Email
                <p-sortIcon field="email" />
              </th>
              <th pSortableColumn="role">
                Role
                <p-sortIcon field="role" />
              </th>
              <th pSortableColumn="jobTitle">
                Job Title
                <p-sortIcon field="jobTitle" />
              </th>
              <th pSortableColumn="serviceGroup">
                Service Group
                <p-sortIcon field="serviceGroup" />
              </th>
              <th pSortableColumn="status">
                Status
                <p-sortIcon field="status" />
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-employee let-i="rowIndex">
            <tr>
              <td class="td-index">{{ i + 1 }}</td>
              <td><span class="member-name">{{ employee.name }}</span></td>
              <td class="member-email">{{ employee.email }}</td>
              <td>{{ employee.role || '—' }}</td>
              <td>{{ employee.jobTitle || '—' }}</td>
              <td>{{ employee.serviceGroup || '—' }}</td>
              <td>
                <span class="member-status member-status--ok">
                  <i class="pi pi-check"></i> {{ employee.status }}
                </span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr class="table-empty-row">
              <td colspan="7" class="table-empty-cell">
                <!-- "Everyone has access" is only true when nothing is filtered out;
                     with filters applied the list is empty for a different reason. -->
                <div class="empty-state" *ngIf="!hasActiveUngroupedFilters()">
                  <div class="empty-icon"><i class="pi pi-check-circle"></i></div>
                  <p class="empty-message">Everyone has access</p>
                  <p class="empty-description">
                    Every active employee holds at least one access role
                  </p>
                </div>
                <div class="empty-state" *ngIf="hasActiveUngroupedFilters()">
                  <div class="empty-icon"><i class="pi pi-inbox"></i></div>
                  <p class="empty-message">No employees found</p>
                  <p class="empty-description">Update filters to see employees</p>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </ng-container>
    </ng-container>
  </div>
</div>
